import { Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom'
import {useMemo, useState } from 'react';
import useLayout from '#Context/Layout'
import Modals from './ModalBodies/AllModals.js'
import './modalStyles.css'
const { WideResumePDF, MobileResumePDF, MessageSuccess, Demo_1Player, Demo_2Player, Demo_Capstone, Page404Modal, DefaultModal } = Modals; 


export default function FlashMsgModal({ modalProps, setModalProps }) {
    // console.log('Modal render', modalProps)
    const { platform } = useLayout();
    let { showing, bodyType, destination, size, dialogClass, contentClass, customContent, callback } = modalProps;
    const [dismiss, setDismiss] = useState(() => {}); 
    const navigate = useNavigate(); 
    // const modalRef = useRef(null) //weird, not very helpful either
    const Body = useMemo(() => {
        switch (bodyType) {
        case 'resumePDF':
            switch (platform) {
            case 'desktop':
                return WideResumePDF;
            case 'mobile':
            default:
                return MobileResumePDF;
            }
        case 'messageSuccess':
            return MessageSuccess;
        case 'mobile1v1':
            return Demo_Capstone
        case 'mobile1':
        case 'tablet1':
        case 'desktop1':
            return Demo_1Player
        case 'mobile2':
        case 'tablet2':
            return Demo_2Player;
        case '404':
            return Page404Modal;
        default:
            return DefaultModal; 
        }
    }, [bodyType])

    return (
        <Modal show={showing} size={size} dialogClassName={dialogClass} contentClassName={contentClass} centered={true} scrollable={true}
            onHide={() => setModalProps({ showing: false })}
            onExiting={dismiss}
            onExited={() => {
                callback && callback(); 
                destination && navigate(destination);
                setModalProps(false); 
                setDismiss(() => { }); 
            }} >
            <Body {...{customContent, setModalProps, setDismiss, platform}}></Body>
        </Modal>
    )

}